import Vue from "vue";
import { EmployeeService } from "@/services/api.service";
import {
  FETCH_EMPLOYEES,
  EMPLOYEE_ADD,
  EMPLOYEE_EDIT,
  EMPLOYEE_DELETE,
  UPLOAD_IMAGE
} from "./actions.type";
import {
  RESET_STATE,
  SET_EMPLOYEE,
  UPDATE_EMPLOYEE_IN_LIST
 // EMPLOYEE_RESET_STATE
} from "./mutations.type";

const initialState = {
  employees: []
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_EMPLOYEES](context, employeeSlug) {
     //console.log(employeeSlug)
    const { data } = await EmployeeService.get();
    context.commit(SET_EMPLOYEE, data.employees);
    //console.log(data)
    return data;
  },
  async [EMPLOYEE_ADD](context, payload) {
    //console.log(payload)
    await EmployeeService.post(payload.slug, payload.data);
    //context.dispatch(FETCH_EMPLOYEES);
  },
  [EMPLOYEE_DELETE](context, slug) {
    return EmployeeService.destroy(slug);
  },
  async [EMPLOYEE_EDIT](context, payload) {
    //console.log(payload)
    await EmployeeService.update(payload.data.id, payload.data);
    //context.dispatch(FETCH_EMPLOYEES);
  },
  async [UPLOAD_IMAGE](context, payload) {
    //console.log(payload)
    await EmployeeService.upload(payload.slug, payload.data);
  },
  [RESET_STATE]({ commit }) {
    commit(RESET_STATE);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_EMPLOYEE](state, employee) {
    state.employee = employee;
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  }
};

const getters = {
  employee(state) {
    return state.employee;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
